import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["min", "max", "step", "value"]

import { ref, watch, computed } from 'vue';

export interface Props {
  editable?: boolean;
  min?: string | number
  max?: string | number ;
  step?: number;
  clamp?: boolean;
  zeroPad?: number;
  pad2?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TapToInput',
  props: /*@__PURE__*/_mergeModels({
    editable: { type: Boolean, default: true },
    min: { default: 0 },
    max: { default: 9999 },
    step: { default: 1 },
    clamp: { type: Boolean, default: false },
    zeroPad: { default: 0 },
    pad2: { type: Boolean, default: false }
  }, {
    "modelValue": { default: 0 },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const value = _useModel(__props, "modelValue");
const psuedoValue = ref(value.value);

const editing = ref(false);
const input = ref();

const props = __props;

function pad(value: number) {
  if (props.zeroPad > 0) {
    return value.toString().padStart(props.zeroPad, '0');
  }
  if (props.pad2) {
    return value.toString().padStart(2, '0');
  }
  return value;
}

const parseValue = (value: string | number | CallableFunction) => {
  if (typeof value === 'number') {
    return value;
  } 
  if (typeof value === 'function') {
    return value();
  }
  return value.includes('.') ? parseFloat(value) : parseInt(value);
};

const minValue = ref(parseValue(props.min));
const maxValue = ref(parseValue(props.max));
const stepValue = ref(parseValue(props.step));

function setValue(event: Event) {
  if (event.target) {
    psuedoValue.value = parseInt((event.target as HTMLInputElement).value);
  }
}

function blurred() {
  editing.value = false;
}

function round(value, toNearest) {
  return Math.round(value / toNearest) * toNearest;
}

const isValid = computed(() => {
  if (psuedoValue.value < minValue.value) {
    return false;
  }
  if (psuedoValue.value > maxValue.value) {
    return false;
  }
  return true;
});

function clampValue(value: number) {
  if (!props.clamp) {
    return value;
  }
  if (value < minValue.value) {
    value = minValue.value;
  } else if (value > maxValue.value) {
    value = maxValue.value;
  }
  if ((value % stepValue.value) !== 0) {
    value = round(value, stepValue.value);
  }
  return value;
}

// watch props
watch(() => props.min, (newVal) => {
  minValue.value = parseValue(newVal);
  psuedoValue.value = clampValue(psuedoValue.value);
});

watch(() => props.max, (newVal) => {
  maxValue.value = parseValue(newVal);
  psuedoValue.value = clampValue(psuedoValue.value);
});

watch(() => props.step, (newVal) => {
  stepValue.value = parseValue(newVal);
});

watch(value, (newVal) => {
  psuedoValue.value = clampValue(newVal);
});


watch(input, (value) => {
  if (value) {
    value.focus();
  }    
});

watch(psuedoValue, (newValue, oldValue) => {
  if (isValid.value) {
    value.value = psuedoValue.value;
    return;
  }
  if (props.clamp) {
    psuedoValue.value = clampValue(newValue);
    value.value = psuedoValue.value;
    return;
  }
  psuedoValue.value = oldValue;
  
});


return (_ctx: any,_cache: any) => {
  return (!editing.value || !props.editable)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (editing.value = !editing.value)),
        ref: "display",
        class: "tti__display"
      }, _toDisplayString(pad(psuedoValue.value)), 513))
    : (_openBlock(), _createElementBlock("input", {
        key: 1,
        type: "number",
        min: minValue.value,
        max: maxValue.value,
        step: stepValue.value,
        value: psuedoValue.value,
        onChange: setValue,
        onBlur: blurred,
        ref_key: "input",
        ref: input,
        class: "tti__input"
      }, null, 40, _hoisted_1))
}
}

})